import {observer} from 'mobx-react';
import {Select2} from 'shared/components';
import {types, endpoints} from 'main/tools';
import _ from 'lodash';

const Project = observer(({model, uiState}) => {
  const {employee} = uiState;

  if (model._type === types.TIME_OFF.ABSENCE || model._type === types.HOLIDAY) return null;

  if (!model.canPatch) {
    return <div>{_.get(model.project, 'name')}</div>;
  }

  return (
    <div className='relative'>
      <Select2
        searchable
        allowClear
        onChange={e => {
          if (e.target.value === null) {
            uiState.updateEntry(model, {project: null});
          } else {
            uiState.updateEntry(model, {
              project: {
                id: e.target.value,
                name: e.target.options[e.target.selectedIndex].text
              }
            });
          }
        }
        }
        defaultValue={model.project?.id}
        by='name'
        endpoint={endpoints.TIME_TRACKING.PROJECTS.FOR_EMPLOYEE.with(employee.id)}
      >
        <option value={model.project?.id}>{model.project?.name}</option>
      </Select2>
    </div>
  );
});

export default Project;
